import Bowser from "bowser";
import { filterXSS } from "xss";
import scrollIntoView from "scroll-into-view";
import { merge, get } from "lodash-es";
import { escapeRegExp } from "../validation_formating/index.es.js";
const isBrowser = typeof window !== "undefined";
const bowser = isBrowser ? Bowser.getParser(window.navigator.userAgent) : null;
const _isOutdatedBrowser = bowser == null ? void 0 : bowser.satisfies({
  ie: "<20",
  safari: "<7",
  chrome: "<40",
  firefox: "<60",
  android: "<4",
  iOS: {
    firefox: "<13"
  }
});
function getCsrfToken() {
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  if (metaTag) {
    return metaTag.getAttribute("content");
  }
  return null;
}
const _isIE = bowser == null ? void 0 : bowser.satisfies({
  ie: ">=1"
});
function isOutdatedBrowser() {
  return !!_isOutdatedBrowser;
}
function isIE() {
  return !!_isIE;
}
function getCookieValue(name) {
  const cookie = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`));
  if (cookie) {
    return cookie.split("=")[1];
  }
  return "";
}
function docReady(fn) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}
const emphasiseQuery = (text, patern) => {
  const filterRE = new RegExp(escapeRegExp(patern), "gi");
  return filterXSS(text.replace(filterRE, (s) => `<b>${s}</b>`));
};
const simpleWrapperCmp = (element = "div") => ({
  render: function(h) {
    return h(element, this.$slots.default);
  }
});
function scrollToElement(el, config = {}, cb) {
  if (!el) {
    return null;
  }
  config = merge(
    {
      // cofiguration ref: https://www.npmjs.com/package/scroll-into-view#how
      time: 200
    },
    config
  );
  const cancel = scrollIntoView(el, config, cb);
  return {
    cancel,
    el
  };
}
function scrollToTop() {
  if (isBrowser) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
}
function getQueryParams(url) {
  if (!url) {
    if (!isBrowser) {
      return {};
    }
    url = window.location.href;
  }
  const params = {};
  const parser = document.createElement("a");
  parser.href = url;
  const query = parser.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
}
function replacePlaceholders(str, params) {
  return urlTemplate(str, params);
}
const urlTemplate = (template, data, fallback) => template && template.replace(
  /:([.\w]+)/g,
  (m, param) => get(data, param) || get(fallback, param) || `:${param}`
);
function redirect(url, $event) {
  const newTab = $event ? $event.ctrlKey || $event.metaKey : false;
  const topmostWindow = window.top || window;
  topmostWindow.open(
    url,
    newTab ? "_blank" : "_self"
  );
  if (topmostWindow.location.href.startsWith(url.split("#")[0]) && url.includes("#")) {
    topmostWindow.location.reload();
  }
}
const deemphasiseQuery = (text) => {
  return text.replace(/<b>|<\/b>/g, "");
};
function ResizeObserverEntryPolyfill() {
  ["borderBoxSize", "contentBoxSize"].forEach((prop) => {
    if (window.ResizeObserver && !ResizeObserverEntry.prototype.hasOwnProperty(prop)) {
      Object.defineProperty(ResizeObserverEntry.prototype, prop, {
        get: function() {
          return calcDimensions(this.target, prop);
        }
      });
    }
  });
}
function calcDimensions(element, prop) {
  const styles = getComputedStyle(element);
  const width = parseFloat(styles.width);
  const height = parseFloat(styles.height);
  const paddingX = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
  const paddingY = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
  const borderXWidth = parseFloat(styles.borderLeftWidth) + parseFloat(styles.borderRightWidth);
  const borderYWidth = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
  let inlineSize = 0;
  let blockSize = 0;
  switch (prop) {
    case "borderBoxSize":
      if (styles.boxSizing === "border-box") {
        inlineSize = width;
        blockSize = height;
      } else {
        inlineSize = width + paddingX + borderXWidth;
        blockSize = height + paddingY + borderYWidth;
      }
      break;
    case "contentBoxSize":
      if (styles.boxSizing === "border-box") {
        inlineSize = width - paddingX - borderXWidth;
        blockSize = height - paddingY - borderYWidth;
      } else {
        inlineSize = width;
        blockSize = height;
      }
      break;
  }
  return [{ inlineSize, blockSize }];
}
function trimTextOnCopy() {
  document.addEventListener("copy", function(e) {
    var _a;
    const selection = (_a = window.getSelection()) == null ? void 0 : _a.toString();
    if (!e.clipboardData || !selection) {
      return;
    }
    const trimmed = selection.trim();
    e.clipboardData.setData("text/plain", trimmed);
    e.preventDefault();
  });
}
export {
  ResizeObserverEntryPolyfill,
  deemphasiseQuery,
  docReady,
  emphasiseQuery,
  getCookieValue,
  getCsrfToken,
  getQueryParams,
  isBrowser,
  isIE,
  isOutdatedBrowser,
  redirect,
  replacePlaceholders,
  scrollToElement,
  scrollToTop,
  simpleWrapperCmp,
  trimTextOnCopy,
  urlTemplate
};
//# sourceMappingURL=index.es.js.map
